import React, {useState} from "react";
import DownloadSummarizedAgencyOrdersReportButtonProperties from "./DownloadSummarizedAgencyOrdersReportButtonProperties";
import {Observer} from "mobx-react-lite";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {Config} from "../../../util/Config";
import {RestClient} from "../../../util/RestClient";
import {Downloader} from "../../../util/Download";
import Button from "../../../ui_components/Button/Button";
import ReceiptIcon from '@mui/icons-material/Receipt';
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import DocumentViewer from "../../../ui_components/DocumentViewer/DocumentViewer";
import PriceInput from "../../Inputs/PriceInput/PricetInput";
import { useStyles } from "./DownloadSummarizedAgencyOrdersReportButton.style";
import UpdateIcon from '@mui/icons-material/Update';
import ObservationsInput from "../../Inputs/ObservationsInput/ObservationsInput";
import MessageCard from "../../../ui_components/MessageCard/MessageCard";

const DownloadSummarizedAgencyOrdersReportButton: React.FC<DownloadSummarizedAgencyOrdersReportButtonProperties> = ({
                                                                                                    from,
                                                                                                    to,
                                                                                                    agencyId,
                                                                                                    className = '',
                                                                                                    text = "Descargar",
                                                                                                    disabled = false,
                                                                                                    rounded = false,
                                                                                                    size = ButtonSize.DEFAULT,
                                                                                                    type = ButtonType.DEFAULT,
                                                                                                    showIcon = true,
                                                                                                    showText = true,
                                                                                                    showPreview = false
                                                                                                }) => {
    const classes = useStyles();
    const label = showPreview ? "Reporte de ventas resumido" : "Descargar reporte de ventas resumido";

    const [cancellationValue, setCancellationValue] = useState(0);
    const [othersValue, setOthersValue] = useState(0);
    const [observation, setObservation] = useState("");

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={onClick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? label : ""}
                text={showText ? label : ""}
                type={type}
                icon={showIcon ? <ReceiptIcon/> : <></>}
            />
        }
        return <Button
            loading={loading}
            text={showText ? label : ""}
            className={className}
            tooltip={!showText ? label : ""}
            disabled={disabled}
            size={size}
            onClick={onClick}
            type={type}
            startIcon={showIcon ? <ReceiptIcon/> : <></>}
        />
    }

    const [url, setUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [openPreview, setOpenPreview] = useState(false);
    const [showReport, setShowReport] = useState(false);

    const formatDate = (timestamp?: number) => {
        const date = new Date(timestamp || 0);
        const month = date.getMonth();
        const year = date.getFullYear();
        const day = date.getDate();
        return `${day}-${month}-${year}`;
    }

    const onClick = async () => {
        if (!showPreview) {
            setLoading(true);
            const response = await RestClient.download(url);
            const fromParsed = formatDate(from);
            const toParsed = formatDate(to);
            let fileName = `resumen_de-ventas(${fromParsed} a ${toParsed}).pdf`;
            if (fromParsed === toParsed) {
                fileName = `resumen_de-ventas(${fromParsed}).pdf`;
            }
            if (response.success) {
                Downloader.download(response.data?.filename || fileName, response.data?.data);
            }
            setLoading(false);
        } else {
            setOpenPreview(true);
        }
    }

    const onLoadPdfClick = async () => {
        const newUrl = Config.get("DOWNLOAD_AGENCY_ORDER_REPORT_SUMMARIZED_URL", {
            from,
            to,
            id: agencyId,
            cancellation: cancellationValue,
            other: othersValue,
            observation
        });
        setUrl(newUrl);
        setShowReport(true);
    }

    const onCancellationValueChange = (newValue: number) => {
       setCancellationValue(newValue);
    };

    const onOtherValueChange = (newValue: number) => {
       setOthersValue(newValue);
    };

    const onObservationChange = async (newObservation: string) => {
        setObservation(newObservation);
    }

    const onClose = () => {
        setOpenPreview(false);
        setShowReport(false);
        setCancellationValue(0);
        setOthersValue(0);
        setObservation("");
    }

    return (
        <Observer>{() => (
            <>
                <Btn/>
                <SidePanel title={"Reporte de ventas resumido"} open={openPreview} onClose={onClose}>
                    <div className={classes.options_container}>
                        <div className={classes.observation_container}>
                            <ObservationsInput
                                label={'Observaciones'}
                                value={observation}
                                lines={3}
                                onChange={onObservationChange}/>
                        </div>
                        <div className={classes.inputs_and_btn_container}>
                            <div className={classes.inputs_container}>
                                <PriceInput 
                                    onChange={onCancellationValueChange} 
                                    value={cancellationValue}
                                    label={"Cancelación"} 
                                />
                                <PriceInput 
                                    onChange={onOtherValueChange} 
                                    value={othersValue}
                                    label={"Otros"}
                                />
                            </div>
                            <div>
                                <Button
                                    loading={loading}
                                    text={"Actualizar"}
                                    size={ButtonSize.SMALL}
                                    onClick={onLoadPdfClick}
                                    type={ButtonType.PRIMARY}
                                    startIcon={<UpdateIcon />}
                                />
                            </div>
                        </div>
                    </div>
                    {showReport && url && <DocumentViewer url={url} />}
                    {!showReport &&
                        <MessageCard icon={UpdateIcon} title={"Use el botón Actualizar para generar el reporte"}
                                        subtitle={"Los datos son opcionales, accione el botón Actualizar para generar el reporte"}/>}
                </SidePanel>
            </>
        )}</Observer>
    );
};

export default DownloadSummarizedAgencyOrdersReportButton;
